module.exports = __webpack_public_path__ + "static/home-hero-5b9324491e0f9fccc53be6abb70faffc.png";